export const userTypeNames = {
  all: "all",
  regular: "regular",
  admin: "admin"
};
